// src/utils/pdfUtils.js
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

let cachedLogoBase64 = null;

const logoUrl = `${process.env.PUBLIC_URL}/assets/logo-tasmik-2.png`;

const loadLogoBase64 = async () => {
    if (cachedLogoBase64) return cachedLogoBase64;

    const res = await fetch(logoUrl);
    const blob = await res.blob();

    return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            cachedLogoBase64 = reader.result; // cache untuk next time
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

export const generateStudentPDF = async (student, schoolName, classroomName) => {
    const doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        compress: true,
        putOnlyUsedFonts: true,
    });

    // --- LOGO (optional, kecilkan supaya fail tak gemuk) ---
    try {
        const logoBase64 = await loadLogoBase64();
        doc.addImage(logoBase64, "PNG", 14, 10, 25, 8);
    } catch (err) {
        console.warn("Gagal muat logo:", err);
    }

    // --- HEADER ---
    doc.setFontSize(12);
    doc.text("Transkrip Bacaan al-Quran", 14, 30);

    doc.setFontSize(10);
    doc.text(`Nama: ${student.name}`, 14, 36);
    doc.text(`Sekolah: ${schoolName}`, 14, 41);
    doc.text(`Kelas: ${classroomName}`, 14, 46);

    // --- TABLE DATA ---
    const tableData =
        student.progress?.map((item, index) => [
            index + 1,
            item.date,
            item.time || "-",
            item.surah,
            `${item.startAyah}-${item.endAyah}`,
            item.ulasan || "",
            item.guru || "",
        ]) || [];

    autoTable(doc, {
        head: [["#", "Tarikh", "Masa", "Surah", "Ayat", "Ulasan", "Guru"]],
        body: tableData,
        startY: 52,
        styles: { fontSize: 9 },
        headStyles: { fillColor: [0, 0, 0], textColor: 255 },
        alternateRowStyles: { fillColor: [245, 245, 245] },
    });

    doc.setFontSize(9);
    doc.text(
        "Dijana oleh Tasmik.com",
        14,
        doc.internal.pageSize.getHeight() - 10
    );

    // --- FILENAME ---
    const safeName = (student.name || "pelajar")
        .replace(/[^\w\- ]+/g, "")
        .replace(/\s+/g, "_");
    const fileName = `Transkrip-${safeName}.pdf`;

    // ❗ Cara recommended jsPDF – satu cara sahaja
    doc.save(fileName);
};
